import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	LINK: '[data-fragment="BalanceListingComponent.link"]',
};

class BalanceListingComponent extends WebComponent {
	constructor(props) {
		super(props);
		const {
			lastItem = null,
		} = props;
		this.state = {
			lastItem,
		};
	}

	didMount() {
		const {
			activeClass,
			nextRowActiveClass,
			showOnlyOneItem,
		} = this.props;

		this.activeClass = activeClass;
		this.nextRowActiveClass = nextRowActiveClass;
		this.showOnlyOneItem = showOnlyOneItem;

		this.on('click', fragments.LINK, this.handleClickOnLink);
	}

	handleClickOnLink = (e) => {
		const {
			lastItem,
		} = this.state;

		e.preventDefault();
		e.stopPropagation();

		this.setState({
			lastItem,
		});
		const _self = this;
		let parentEl = e.target.parentElement.parentElement.parentElement;
		if (this.showOnlyOneItem) {
			if (lastItem && lastItem !== parentEl) {
				this.closeItem(lastItem);
			}
		}

		if (!parentEl.classList.contains(this.activeClass)) {
			setTimeout(function () {
				_self.openItem(parentEl);
			}, 200);
		} else {
			this.closeItem(parentEl);
		}
	};

	openItem = (el) => {
		el.classList.add(this.activeClass);
		this.setState({ lastItem: el });
		let i;
		let nextEl = el.nextElementSibling;
		for(i = 0;i < 3; i++){
			nextEl.classList.add(this.nextRowActiveClass);
			nextEl = nextEl.nextElementSibling;
		}
	};

	closeItem = (el) => {
		el.classList.remove(this.activeClass);
		let i;
		let nextEl = el.nextElementSibling;
		for(i = 0;i < 3; i++){
			nextEl.classList.remove(this.nextRowActiveClass);
			nextEl = nextEl.nextElementSibling;
		}
	};


	willUnMount() {
		this.elements = null;
	}


}

BalanceListingComponent.defaultProps = {
	activeClass: 'balance-listing__row--active',
	nextRowActiveClass: 'balance-listing__row--show',
	showOnlyOneItem: true,
};

export default BalanceListingComponent;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/BalanceListingComponent.js